import { render } from "./CountryProfileOpportunity.vue?vue&type=template&id=33136548"
import script from "./CountryProfileOpportunity.vue?vue&type=script&lang=js"
export * from "./CountryProfileOpportunity.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__